/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_PasskeyInputs */

const en_signin_passkey = /** @type {(inputs: Signin_PasskeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with a passkey`)
};

/** @type {(inputs: Signin_PasskeyInputs) => LocalizedString} */
const ar_signin_passkey = en_signin_passkey;

/** @type {(inputs: Signin_PasskeyInputs) => LocalizedString} */
const he_signin_passkey = en_signin_passkey;

/** @type {(inputs: Signin_PasskeyInputs) => LocalizedString} */
const ur_signin_passkey = en_signin_passkey;

/** @type {(inputs: Signin_PasskeyInputs) => LocalizedString} */
const es_signin_passkey = en_signin_passkey;

/** @type {(inputs: Signin_PasskeyInputs) => LocalizedString} */
const fr_signin_passkey = en_signin_passkey;

/** @type {(inputs: Signin_PasskeyInputs) => LocalizedString} */
const de_signin_passkey = en_signin_passkey;

/** @type {(inputs: Signin_PasskeyInputs) => LocalizedString} */
const pt_signin_passkey = en_signin_passkey;

/** @type {(inputs: Signin_PasskeyInputs) => LocalizedString} */
const hi_signin_passkey = en_signin_passkey;

/** @type {(inputs: Signin_PasskeyInputs) => LocalizedString} */
const bn_signin_passkey = en_signin_passkey;

/**
* | output |
* | --- |
* | "Sign in with a passkey" |
*
* @param {Signin_PasskeyInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_passkey = /** @type {((inputs?: Signin_PasskeyInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_PasskeyInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_passkey(inputs)
	if (locale === "he") return he_signin_passkey(inputs)
	if (locale === "ur") return ur_signin_passkey(inputs)
	if (locale === "es") return es_signin_passkey(inputs)
	if (locale === "fr") return fr_signin_passkey(inputs)
	if (locale === "de") return de_signin_passkey(inputs)
	if (locale === "pt") return pt_signin_passkey(inputs)
	if (locale === "hi") return hi_signin_passkey(inputs)
	if (locale === "bn") return bn_signin_passkey(inputs)
	return /** @type {LocalizedString} */ ("Sign in with a passkey")
});